import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {getAvailableCategories} from 'topmeteo/general/selectors';

import ResetFavourites from 'topmeteo/base-image/components/Matrix/ResetFavourites';
import FavouritesOnlyToggle from 'topmeteo/base-image/components/Matrix/FavouritesOnlyToggle';

import TableFoot from './TableFoot';
import PreselectionMessage from './PreselectionMessage';
import NoFavouritesSelectedMessage from './NoFavouritesSelectedMessage';

const FavouritesMessage = gettext('Favorites can only be customized on the desktop page.');

const FavouritesArea = ({categoriesAvailable}) => (
    <div className="favorites-area">
        <div className="container">
            <TableFoot />
            {categoriesAvailable || <NoFavouritesSelectedMessage />}
            <div className="table-foot">
                <div id="show-all-favorites">
                    <FavouritesOnlyToggle />
                </div>
                <div id="reset-favorites">
                    <ResetFavourites />
                </div>
                {categoriesAvailable && <PreselectionMessage />}
                <p className="mobile-only">{FavouritesMessage}</p>
            </div>
        </div>
    </div>
);

const mapStateToProps = state => {
    const categories = getAvailableCategories(state);

    return {
        categoriesAvailable: Boolean(categories.length),
    };
};

export default connect(mapStateToProps)(FavouritesArea);
